<template>
  <div>
    <!-- <van-nav-bar title="选择支付方式" /> -->
    <van-row class="xzzffs">
      <van-col span="24" class="xzzffsMoney">
        <p>订单总额</p>
        <!-- <h3 class="bmfyTitle">2022-2023年《中国卫生信息管理杂志》电子期刊</h3> -->
        <h2>￥{{ order_money }}</h2>
      </van-col>
      <van-form @submit="onSubmit">
        <van-col span="24">
          <van-radio-group v-model="radio">
            <van-cell-group>
              <van-cell title="微信(推荐)" size="large" icon="wechat" clickable @click="radio = '1'">
                <template #right-icon>
                  <van-radio name="1" checked-color="#61ba46" shape="square" />
                </template>
              </van-cell>
			  <!-- 跳过发票信息 2026-07-07 -->
              <!-- <van-cell title="对公转账或现场刷卡" size="large" icon="card" clickable @click="radio = '2'" v-if="meetingId != 45">
                <template #right-icon>
                  <van-radio name="2"  checked-color="#e99e27" shape="square" />
                </template>
              </van-cell> -->
            </van-cell-group>
          </van-radio-group>
          <div style="margin:50px 16px 16px;"><van-button style="font-size: 16px;" round block type="info" native-type="submit">{{radio == '2'?'提交':'去支付'}}</van-button></div>
        </van-col>
      </van-form>
    </van-row>
  </div>
</template>

<script>
export default {
    injec:['reload'],
    data() {
        return {
			meetingName: this.$cookies.get('meetingName'),
			meetingId: this.$cookies.get('meetingId'),
            radio: '1',
            order_money:'',
            outTradeNo:this.$cookies.get('cookise_order_outTradeNo'),
            appId:'',
            nonceStr:'',
            package:'',
            paySign:'',
            signType:'',
            timeStamp:'',
            time_:'',
            code:''
        };
    },
    created(){
      this.jzht();
      this.getEnteredListByCurrent();
      this.getOrderStatusInfo();
    },
    methods:{
      jzht(){
        history.pushState(null, null, document.URL); //禁止网页返回上一页
        window.addEventListener('popstate', function() {
          history.pushState(null, null, document.URL);
        });
      },
        getEnteredListByCurrent(){
          this.order_money = this.$cookies.get('cookies_meeting_order_payMoney');
        },
        /**
         * POST 微信浏览器中，获取预支付id
         * @bodyParam paramap true
         */
        getPrepayId_f(){
			// alert(this.$cookies.get('openid'),sessionStorage.getItem('openid'));
          var data ={
              'body' : '报名费',
              'outTradeNo' : this.outTradeNo,
              'openId' : sessionStorage.getItem('openid') == null?this.$cookies.get('openid'):sessionStorage.getItem('openid')
          }
          this.axios.post('/api/appweb/wxpay/getPrepayId',data).then(res=>{
            // console.log(res.data.data);
            if(res.status == 200){
              this.getPayParameterForPage_f(res.data.data)
            }
          })
        },
        /**
         * GET 生成JSAPI页面调用的支付参数并签名
         * @queryParam prepayId true
         */
        getPayParameterForPage_f(prepayId){
          this.axios.get('/api/appweb/wxpay/getPayParameterForPage',{params:{'prepayId': prepayId,'meetingId':sessionStorage.getItem('meetingId')}}).then(res=>{
            if (res.status == 200) {
              var config = res.data.data;
              // console.log(config)
              this.appId = config.appId;
              this.nonceStr = config.nonceStr;
              this.package = config.package;
              this.paySign = config.paySign;
              this.signType = config.signType;
              this.timeStamp = config.timeStamp;
              this.onBridgeReady();
            }

          })
        },
        onBridgeReady() {
          wx.config({
              debug: false, // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
              appId: this.appId, // 必填，公众号的唯一标识
              timestamp: this.timeStamp, // 必填，生成签名的时间戳
              nonceStr: this.nonceStr, // 必填，生成签名的随机串
              signature: this.paySign, // 必填，签名
              jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
            })
            wx.ready(() => {
              wx.checkJsApi({
                jsApiList: ['chooseWXPay'],
                success:function(res){
                  console.log("seccess",res)
                  // console.log('hskdjskjk', res)
                },
                fail:function(res){
                  // console.log("fail"); x
                  // console.log(res)
                  }
                })
              wx.chooseWXPay({
                  timestamp: this.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                  nonceStr: this.nonceStr, // 支付签名随机串，不长于 32 位
                  package: this.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: this.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                  paySign: this.paySign, // 支付签名
                  success: function (res) {  // 支付成功后的回调函数
                    window.location.href='/BaoMing/Wapbm/dist/charge/pay/index'
                  },
                  fail: function (res) {
                    this.$toast.fail("支付失败,请重试！");
                    // alert(res.errMsg);
                  }
                })
            })
            wx.error(err => {
              alert(err)
            })


        },
        getOrderStatusInfo() {
        	//getOrderStatus
        	this.time_ = window.setInterval(this.huidiao(), 1000);
        },
        huidiao(){
          this.axios.get('/api/appweb/wxpay/queryOrder',{params:{'outTradeNo':this.outTradeNo}}).then(res=>{
              if (res.data.status == '200') {
              	if(res.data.data){
              		if (res.data.data.trade_state == 'SUCCESS') {
              			window.clearInterval(this.time_);
              			this.$router.push('/charge/pay/index');
              		}
              	}

              }
          })
        },
        onSubmit(values){
            if(this.$data.radio == 1){
               this.getPrepayId_f();
            }else if(this.$data.radio == 2){
              var data ={
                  'outTradeNo' : this.outTradeNo,
              }
              this.axios.post('/api/appweb/wxpay/offlinePay',data).then(res=>{
                if(res.data.status== 200){
					sessionStorage.setItem('transfer',JSON.stringify(res.data.data));
                  this.$router.push('/charge/remittance');
                }else{
                  this.$toast.fail("提交失败！");
                }
              })
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-cell--large {
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #f6f6f6;
}
.van-cell--large .van-cell__left-icon {
  font-size: 30px;
  color: #f2af55;
}
.van-cell--large .van-icon-wechat {
  color: #20ac38;
}
.xzzffsMoney {
  padding: 10px 20px 30px;
}
.xzzffsMoney h2 {
  text-align: center;
  font-size: 40px;
  color: #d00;
  font-weight: normal;
}
.van-cell--large::after{
  border-bottom: 1px solid #e5e5e5;
}
h3.bmfyTitle{
    color:#c81a1a;
    font-weight: bold;
    margin-bottom: 0;
    font-size: 16px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Charge/pay.vue